
import { Variables } from "../../../variables";
import { Component, Vue } from "vue-property-decorator";
import { accountApi } from "../../services/api/account/account";
import { LoginCommand } from "../../services/api/models/LoginCommand.model";
import { LoginInfoCommand } from "../../services/api/models/LoginInfoCommand.model";
import { profileApi } from "../../services/api/profile/profile";
import AnonymousLayout from "../../layouts/AnonymousLayout.vue";
import TwoFactorCode from "../../components/TwoFactorCode.vue";
import SelectProfile from "../../components/SelectProfile.vue";
import VueRecaptcha from "vue-recaptcha";
import * as tf from "@tensorflow/tfjs";

@Component({
  components: { AnonymousLayout, VueRecaptcha, TwoFactorCode, SelectProfile },
})
export default class Login extends Vue {
  private loading = false;
  private returnUrl = "";
  private remember = false;
  private user = "";
  private userErrors = [];
  private pass = "";
  private passErrors = [];
  private errors: string[] = [];
  private error_code = "";
  private showPassword = false;
  private reCaptchaResponse = "";
  private skipCaptchaKey = "";
  private modalProfile = false;
  private modalTwoFactor = false;
  private profiles = [];
  private disabledFacial = true;
  $route: any;
  $router: any;

  get sitekeyRecaptcha() {
    return Variables.SitekeyRecaptcha;
  }

  async created() {
    this.returnUrl =
      (this.$route.query.returnUrl as string) ||
      (this.$route.query.ReturnUrl as string) ||
      "";
    let response = await accountApi.loginInfo(
      new LoginInfoCommand(this.returnUrl)
    );

    this.remember = response.rememberLogin;
    this.user = response.username;

    this.reCaptchaResponse = "skip";
  }

  get disabledLogin(): boolean {
    return (
      this.user === "" ||
      this.pass === "" ||
      (this.reCaptchaResponse === "" &&
        (this.skipCaptchaKey === "" || this.skipCaptchaKey === undefined)) ||
      this.user === undefined ||
      this.pass === undefined ||
      (this.reCaptchaResponse === "" &&
        (this.skipCaptchaKey === "" || this.skipCaptchaKey === undefined))
    );
  }

  onVerify(response: any) {
    this.reCaptchaResponse = response ?? "";
  }

  onExpired() {
    console.log("expired");
  }

  resetRecaptcha() {
    let recaptcha: any = this.$refs.recaptcha;
    recaptcha.reset();
  }

  async login() {
    if (this.disabledLogin) return;

    this.loading = true;

    this.userErrors = [];
    this.passErrors = [];
    this.errors = [];
    this.error_code = "";

    try {
      const request = new LoginCommand(
        this.returnUrl,
        this.user,
        this.pass,
        this.remember,
        this.reCaptchaResponse,
        this.skipCaptchaKey,
        ""
      );
      const response = await accountApi.login(request);
      await this.redirectUrl(response, response.twoFactor);
    } catch (err) {
      if (err?.response?.status === 400) {
        let data = err.response.data;
        if (data.Username !== undefined) {
          this.userErrors = data.Username;
        }
        if (data.Password !== undefined) {
          this.passErrors = data.Password;
        }
        if (data.errors !== undefined) {
          this.errors = data.errors;
        }
        if (data.message !== undefined) {
          this.errors.push(data.code);
          if (data.code === "force_change_password") {
            await this.$router.push({
              name: "ForgotPassword",
              params: { forceChangePassword: true },
            });
          }
        }
      }
    } finally {
      this.loading = false;
      if (this.reCaptchaResponse !== "skip") {
        this.resetRecaptcha();
      }
      this.reCaptchaResponse = "";
    }
  }

  setUser() {
    this.checkCedula();
    this.disabledFacial = this.user === "" || this.user === undefined;
  }

  checkCedula() {
    var pattern =
      /^(PE|E|N|[23456789](?:AV|PI)?|1[0123]?(?:AV|PI)?)-(\d{1,4})-(\d{1,7})$/i;

    if (pattern.test(this.user) || this.user == "K250663") {
      return true;
    }

    return false;
  }

  async facial() {
    if (this.disabledFacial) return;

    let query: any = {
      identification: this.user,
    };

    if (this.returnUrl !== "") {
      query.returnUrl = this.returnUrl;
    }

    await this.$router.push({
      name: "Facial",
      query: query,
    });
  }

  async checkBackend() {
    await tf.ready();
    const backend = tf.getBackend();
    return backend == "webgl";
  }

  isWebGLSupported() {
    try {
      const canvas = document.createElement("canvas");
      const gl =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      return !!gl;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async redirectUrl(response: any, twoFactor: any = false) {
    this.modalTwoFactor = false;
    this.modalProfile = false;

    if (twoFactor === true) {
      this.modalTwoFactor = true;
      return;
    }

    if (response.returnUrl.includes("additional%3Aprofile")) {
      this.profiles = await profileApi.getAdditionalProfiles();
      if (Object.entries(this.profiles).length > 0) {
        this.modalProfile = true;
        return;
      }
    }

    window.location.href = response.returnUrl;
  }
}
